import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));
  ${bp('sm')`
    display: block;
  `}
`
